/* SiteGridViewComponent.js */

"use strict";

// const BaseEntity = require("@gluenetworks/platform-sdk-remote/dist/entities/base_evented_sdk/BaseEntity");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./SiteGridViewRenderer");
const Registrations = require("../../../../../RegistrationNamespaces");

const PagingSitesFeed = require("./PagingSiteFeed");
const TreeUtils = require("../../treeUtilities");
const deleteSiteUtility = require("../../deleteSiteUtility.js");

const DateColumn = require("./column_renderers/date/DateComponent");
const PathColumn = require("./column_renderers/path/PathComponent");
const parentNameColumn = require("./column_renderers/parentname/parentNameComponent");
const LocationTypeColumn = require("./column_renderers/locationtype/LocationTypeComponent");
const ContactFieldColumn = require("./column_renderers/contactfields/ContactFieldComponent");
const AutoAssignPropertyColumn = require("./column_renderers/auto_assign_property/AutoAssignPropertyComponent");
const DiscoverLevelColumn = require("./column_renderers/discovery_level/DiscoveryLevelComponent");
const CustomFieldsColumn = require("../../../deviceexplorer/views/device_grid_view/column_renderers/custom_fields/CustomFieldsComponent");

const _ = require("lodash");

class SiteGridViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        steveUtils,
        userSession,
        storageFactory,
        solutionsManager,
        modalUserFeedback,
        licenseRestriction,
        di,
        SiteEntity,
        CustomFields,
        CredentialsEntity
    ) {
        super(di);
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._steveUtils = steveUtils;
        // this._VendorApiConfigEntityDef = VendorApiConfigEntity;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "siteExplorer";
        this._siteEntityDef = SiteEntity;
        this._CustomFieldsEntityDef = CustomFields;
        this._storageFactory = storageFactory;
        this._credentialsEntityDef = CredentialsEntity;
        this._credentialNameOptions = {};
        this._userGridData = undefined; //new UserGridData(this._gridKey);
        this._pagingSiteFeed = undefined;
        this._siteFeed = undefined;
        this._isCiscoSupportEnabled = undefined;
        this._isNistSupportEnabled = undefined;
        this._renderer = new Renderer(this);
        this._explorerState = {
            selectedIds: [],
            //openedEditor: undefined,
            openedTabs: {},
            activeTab: undefined,
        };
        this.columns = undefined;
        this._customFieldColumnsEntity = undefined;
        this._vendorApiConfigEntity = undefined;
        this._isEmitCustomFieldEvent = undefined;
        this._sessionStorage = undefined; //new UserGridData(`${this._gridKey}_explorerState`, null, { storageKey: 'deviceExplorer_explorerState', storageType: 'session' });
        this._osMap = undefined;
        this._licenseRestriction = licenseRestriction;
        this._sitesList = undefined;
        this._di = di;
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }
        const optionMapSitePaths = _.isFunction(this.gameEditor._sitePaths.map)
            ? this.gameEditor._sitePaths.map(({id, path}) => ({
                  title: path
                      ? path.replace("/" + this._userSession.activeOrganization.name + "/", "/")
                      : "/",
                  name: id,
              }))
            : [];
        // optionMapSitePaths.unshift({title: "/", name: null});

        const autoAssignPropertyLabels = this._siteEntityDef.getAutoAssignPropertyLabels();
        // const optionAutoAssignPropertyPaths = Object.keys(autoAssignPropertyLabels).forEach((key) => ({
        //     title: autoAssignPropertyLabels[key],
        //     name: key
        // }));

        const optionAutoAssignPropertyPaths = {};
        Object.keys(autoAssignPropertyLabels).forEach(
            (key) =>
                (optionAutoAssignPropertyPaths[key] = {
                    name: key,
                    title: autoAssignPropertyLabels[key],
                })
        );
        this.columns = {
            grouping: {
                label: "Group",
                width: 220,
                priority: 0,
                shown: false,
                entityColumn: true,
                isGroupingColumn: true,
            },
            locationType: {
                label: "Type",
                width: 45,
                resizable: false,
                priority: 1,
                groupable: true,
                shown: true,
                context: {
                    _labels: this._siteEntityDef.getLocationTypeLabels(),
                },
                columnRendererComponent: LocationTypeColumn,
                options: Object.entries(this._siteEntityDef.getLocationTypeLabels()).map(
                    ([value, title]) => ({name: value, title})
                ),
            },
            codeName: {
                label: "Code Name",
                width: 220,
                shown: true,
                groupable: true,
                priority: 2,
            },
            name: {
                label: "Name",
                shown: true,
                width: 300,
                groupable: true,
                priority: 3,
            },
            uniqueName: {
                label: "Unique Name",
                groupable: false,
                shown: false,
                width: 140,
                priority: 4,
            },
            description: {
                label: "Description",
                groupable: false,
                shown: true,
                width: 140,
                priority: 5,
            },
            parentId: {
                label: "Path",
                groupable: false,
                shown: true,
                width: 140,
                priority: 6,
                dataType: "pathlist",
                entityColumn: true,
                context: {
                    options: optionMapSitePaths,
                    orgName: this._userSession.activeOrganization.name,
                },
                columnRendererComponent: PathColumn,
                options: optionMapSitePaths,
            },
            parentName: {
                label: "Parent Site Name",
                groupable: true,
                shown: false,
                context: {
                    orgName: this._userSession.activeOrganization.name,
                },
                columnRendererComponent: parentNameColumn,
                width: 140,
                priority: 7,
            },
            adminContact: {
                label: "Admin Contact",
                groupable: true,
                shown: false,
                width: 140,
                priority: 8,
                columnRendererComponent: ContactFieldColumn,
            },
            technicalContact: {
                label: "Technical Contact",
                groupable: true,
                shown: false,
                width: 140,
                priority: 9,
                columnRendererComponent: ContactFieldColumn,
            },
            location: {
                label: "Location",
                groupable: true,
                shown: false,
                width: 140,
                priority: 10,
            },
            address: {
                label: "Address",
                groupable: false,
                shown: false,
                width: 140,
                priority: 11,
            },
            country: {
                label: "Country/Region",
                groupable: true,
                shown: false,
                width: 140,
                priority: 12,
            },
            latitude: {
                label: "Latitude",
                groupable: false,
                shown: false,
                width: 140,
                priority: 13,
            },
            longitude: {
                label: "Longitude",
                groupable: false,
                shown: false,
                width: 140,
                priority: 14,
            },
            credsName: {
                label: "Credential",
                groupable: true,
                shown: false,
                options: this._credentialNameOptions,
                width: 140,
                priority: 15,
            },
            timezone: {
                label: "Timezone",
                groupable: true,
                shown: false,
                width: 140,
                priority: 15,
            },
            autoAssignEnabled: {
                label: "Auto-assign Enabled",
                groupable: false,
                shown: false,
                width: 140,
                priority: 16,
            },
            autoAssignProperty: {
                label: "Auto-assign Property",
                groupable: true,
                shown: false,
                width: 140,
                priority: 17,
                options: optionAutoAssignPropertyPaths,
                context: {
                    _labels: autoAssignPropertyLabels,
                },
                columnRendererComponent: AutoAssignPropertyColumn,
            },
            autoAssignRegex: {
                label: "Auto-assign RegEx",
                groupable: false,
                shown: false,
                width: 140,
                priority: 18,
            },
            discoveryLevel: {
                label: "Discovery Level",
                columnRendererComponent: DiscoverLevelColumn,
                groupable: true,
                options: Object.entries(this._siteEntityDef.getDiscoveryLevelLabels()).reduce(
                    (acc, [val, title]) => {
                        acc[val] = {name: val, title};
                        return acc;
                    },
                    {}
                ),
                shown: false,
                width: 140,
                priority: 19,
            },
            deviceCount: {
                label: "Devices",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            childSiteCount: {
                label: "Sites",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            updatedOn: {
                label: "Updated On",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
                columnRendererComponent: DateColumn,
            },
            updatedBy: {
                label: "Updated By",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            createdOn: {
                label: "Created On",
                groupable: false,
                shown: false,
                width: 140,
                priority: 19,
                columnRendererComponent: DateColumn,
            },
            createdBy: {
                label: "Created By",
                groupable: false,
                shown: false,
                width: 140,
                priority: 19,
            },
        };
        return this.columns;
    }

    get pagingFeed() {
        return this._pagingSiteFeed;
    }

    get selectedRows() {
        return this._renderer.selectedRows;
    }

    get activeOrgId() {
        return this._userSession.activeOrganization.id;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // this._solutionsManager.on("activeSolutionChanged", (this._onSolutionChanged = this._onSolutionChanged.bind(this)));
        this._storageFactory.on(
            "storageReady",
            (this._onStorageReady = this._onStorageReady.bind(this))
        );
        this._gameEditor.on(
            "EditorLaunched",
            (this._onEditorLaunched = this._onEditorLaunched.bind(this))
        );
        this._gameEditor.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._gameEditor.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));
    }

    _unregisterListeners() {
        // this._solutionsManager.removeListener("activeSolutionChanged", this._onSolutionChanged);

        this._storageFactory.removeListener("storageReady", this._onStorageReady);
        this._gameEditor.removeListener("EditorLaunched", this._onEditorLaunched);
        this._gameEditor.removeListener("EditorClosed", this._onEditorClosed);
        this._gameEditor.removeListener("ActiveTabChanged", this._onActiveTabChanged);
        this._gameEditor.removeAllListeners();
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    _registerFeedListeners() {
        this._onSiteFeedUpdated = _.debounce(this._onSiteFeedUpdated.bind(this), 5000, {
            leading: true,
            trailing: true,
        });
        this._siteFeed.on("EntityPropertiesUpdated", this._onSiteFeedUpdated);
        this._siteFeed.on("EntityAdded", this._onSiteFeedUpdated);
        this._siteFeed.on("EntityRemoved", this._onSiteFeedUpdated);
    }

    _unregisterFeedListeners() {
        this._onSiteFeedUpdated.cancel();
        this._siteFeed.removeListener("EntityPropertiesUpdated", this._onSiteFeedUpdated);
        this._siteFeed.removeListener("EntityAdded", this._onSiteFeedUpdated);
        this._siteFeed.removeListener("EntityRemoved", this._onSiteFeedUpdated);
    }

    _startSiteFeed() {
        this._siteFeed = this._siteEntityDef.startSitesFeed(
            this.activeOrgId,
            {},
            {path: true, name: true, locationType: true},
            {updatedOn: -1}
        );
        return this._siteFeed.whenInitialized().then((sitesFeed) => {
            this._siteFeed = sitesFeed;
            this._registerFeedListeners();
        });
    }

    _stopSiteFeed() {
        if (!this._siteFeed) {
            return Promise.resolve();
        }
        this._unregisterFeedListeners();
        return this._siteFeed.shutdown().then(() => {
            this._siteFeed = undefined;
        });
    }

    _registerUpdatedColumnListeners() {
        this._customFieldColumnsEntity.on(
            "PropertiesUpdated",
            (this._onPropertiesUpdated = this._onPropertiesUpdated.bind(this))
        );
    }

    _unregisterUpdatedColumnListeners() {
        if (this._customFieldColumnsEntity) {
            this._customFieldColumnsEntity.removeListener(
                "PropertiesUpdated",
                this._onPropertiesUpdated
            );
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    whenModelIsReady(treeSelectedSite) {
        return this.gameEditor
            .whenInitialized()
            .then(() => {
                this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                    "entity_grid_gl",
                    this._gridKey
                );
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                this._explorerState = Object.assign(
                    {},
                    this._explorerState,
                    this._sessionStorage.getData()
                );
            })
            .then(() => {
                // console.time( "loadVendorApiConfigAndColumnDef" );
                return Promise.all([
                    this._CustomFieldsEntityDef.loadColumnDefinitions(this.activeOrgId),
                    this._CustomFieldsEntityDef.retrieveCustomFields(this.activeOrgId),
                ]);
            })
            .then((response) => {
                const customFieldColumns = response[0];
                this._customFieldColumnsEntity = response[1];
                let columnConfigMaxPriority = Math.max(..._.map(this.columnConfig, "priority"));

                let enabledCustomColumns = Object.entries(customFieldColumns)
                    .filter(
                        ([, customField]) =>
                            customField.enabled === true && !_.get(customField, "deviceOnly", true)
                    )

                    .sort(([, /*aKey*/ aCustomField], [, /*bKey*/ bCustomField]) =>
                        // Sort custom fields according to its 'order'
                        this._CustomFieldsEntityDef
                            .getSortingComparator("order")
                            .call(null, aCustomField, bCustomField)
                    )
                    .map(([key, customField], idx) => {
                        // Build grid column object for each custom field
                        // const predefinedCustomField = _.find(DEVICE_CUSTOM_FIELDS, { id: key });
                        // const columnRendererComponent = _.get(
                        //     predefinedCustomField,
                        //     "columnRenderer",
                        //     CustomFieldsColumn
                        // );
                        const customFieldColumn = {
                            label: customField.label,
                            description: customField.description || customField.label,
                            entityColumn: false,
                            shown: false,
                            path: `customFieldValues.${key}`,
                            dataType: String(customField.dataType).toLowerCase(),
                            typeInfo: customField.typeInfo || {},
                            context: _.clone(customField),
                            priority: columnConfigMaxPriority + idx + 1,
                            columnRendererComponent: CustomFieldsColumn,
                        };

                        const {labels, ids, multiSelect} = customFieldColumn.typeInfo || {};
                        if (labels && ids && multiSelect !== true) {
                            customFieldColumn.options = ids.reduce(
                                (options, id, idx) =>
                                    Object.assign(options, {[id]: {title: labels[idx]}}),
                                {}
                            );
                        }

                        return {[key]: customFieldColumn};
                    });
                _.assign(this.columnConfig, ...enabledCustomColumns);
                this._registerUpdatedColumnListeners();
            })
            .then(() => {
                const userSorting = this._userGridData.getSorting() || {};
                this._patchSorting(userSorting);
                return this._startSiteFeed();
            })
            .then(() => this._loadAllSites())
            .then(() => {
                this._credentialsEntityDef
                    .loadLabelValues(this.activeOrgId, {$exists: true})
                    .then((results) => {
                        results.forEach(
                            ({label}) =>
                                (this._credentialNameOptions[label] = {name: label, title: label})
                        );

                        Object.assign(this.columnConfig.credsName, {
                            options: this._credentialNameOptions,
                        });
                    });
            })
            .then(() => {
                const basicFilterQuery = _.get(
                    this._userGridData.getBasicSearchData(),
                    "filterQuery",
                    {}
                );
                const advancedFilterQuery = this._userGridData.getAdvancedSearchData();

                const userSorting = this._userGridData.getSorting() || {};
                this._patchSorting(userSorting);
                let filterQuery = !_.isEmpty(advancedFilterQuery)
                    ? advancedFilterQuery
                    : basicFilterQuery;
                const oldQuery = _.clone(filterQuery);
                filterQuery = {
                    $userQuery: oldQuery,
                    $systemQuery: {},
                };
                this.treeData = this.generateTreeData(undefined, treeSelectedSite);
                if (treeSelectedSite) {
                    // console.log(selectedSite, this.treeData);
                    const {pathVals, selectedSitePath} = TreeUtils.getAllChildrenPathsFromId(
                        this.treeData,
                        treeSelectedSite
                    );
                    if (selectedSitePath === "/") {
                        this._filterForTree = {};
                    } else if (pathVals) {
                        this._filterForTree = {path: {$in: pathVals}};
                    }
                    // this._updateFilter("ontoggle", false, false);
                }

                if (typeof filterQuery !== "object") {
                    filterQuery = {};
                }
                let _filter = JSON.parse(JSON.stringify(filterQuery));
                if (!_.isEmpty(this._filterForTree)) {
                    let userQ = {};
                    if (_filter.$userQuery) {
                        if (_filter.$userQuery.$and) {
                            userQ.$and = _filter.$userQuery.$and;
                        } else if (_filter.$userQuery.$or) {
                            userQ.$and = [{$or: _filter.$userQuery.$or}];
                        } else {
                            userQ.$and = [];
                        }
                    } else {
                        userQ.$and = [];
                    }
                    userQ.$and.push(this._filterForTree);
                    _filter.$userQuery = userQ;
                }

                this._pagingSiteFeed = new PagingSitesFeed({
                    entityDef: this._siteEntityDef,
                    feedKey: this._gridKey + "_feed",
                    activeOrgId: this.activeOrgId,
                    columnConfig: this.columnConfig,
                    additionalDataFields: ["path", "customFieldValues"],
                    filter: _filter,
                    sort: userSorting,
                });

                return this.whenFeedIsReady();
            });
    }
    wasFeedPreviouslyInitialized() {
        return this._pagingSiteFeed.wasPreviouslyInitialized();
    }

    whenFeedIsReady() {
        return this._pagingSiteFeed.whenFeedReady();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        this._unregisterUpdatedColumnListeners();
        const shutdowns = [
            _.isUndefined(this._renderer) ? Promise.resolve() : this._renderer.shutdown(),
            _.isUndefined(this._pagingSiteFeed)
                ? Promise.resolve()
                : this._pagingSiteFeed.shutdown(),
            this._stopSiteFeed(),
            _.isUndefined(this._sessionStorage)
                ? Promise.resolve()
                : this._sessionStorage.shutdown(),
        ];

        return Promise.all(shutdowns).then(
            () => {
                //this._gameEditor._unregisterDeviceExplorerListeners();
                this._gameEditor = undefined;
                this._renderer = undefined;
                this._steveUtils = undefined;
                this._explorerState = undefined;
                this._pagingSiteFeed = undefined;
                this._VendorApiConfigEntityDef = undefined;
                this._isCiscoSupportEnabled = undefined;
                this._isNistSupportEnabled = undefined;
                this._userSession = undefined;
                this._modalUserFeedback = undefined;
                this._solutionsManager = undefined;
                this._solutionName = undefined;
                this._gridKey = undefined;
                this._userGridData = undefined;
                this._sessionStorage = undefined;
                this._logger = undefined;
                this._customFieldColumnsEntity = undefined;
                this._isEmitCustomFieldEvent = undefined;
                this._sitesList = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "SiteGridViewComponent.shutdown() error");
            }
        );
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get explorerState() {
        return this._explorerState;
    }

    set explorerState(val) {
        this.setExplorerState(val);
    }

    setExplorerState(val) {
        this._explorerState = val;
    }

    updateExplorerState(property, val) {
        if (val === undefined) {
            this._sessionStorage.removeData(property);
            _.unset(this._explorerState, property);
        } else {
            this._sessionStorage.setData(val, property);
            _.set(this._explorerState, property, val);
        }
    }

    get isCiscoSupportEnabled() {
        return this._isCiscoSupportEnabled;
    }

    set isCiscoSupportEnabled(isEnabled) {
        this._isCiscoSupportEnabled = isEnabled;
    }

    get isNistSupportEnabled() {
        return this._isNistSupportEnabled;
    }

    set isNistSupportEnabled(isEnabled) {
        this._isNistSupportEnabled = isEnabled;
    }

    resetSelection(newIds) {
        let selectedIds = [];

        if (newIds && newIds.length) {
            newIds.forEach((id) => {
                selectedIds.push(id);
            });
        }

        this.renderer._siteEntityGrid.setSelectedRows(selectedIds);
        this.updateExplorerState("selectedIds", {selectedRows: selectedIds});
        this.renderer._renderAvailableActions();
    }

    loadAndScrollTo(entityId) {
        let that = this;
        this.pagingFeed.on("RequestedEntityFound", handleRequestedEntityFound);
        this.pagingFeed._requestEntity(entityId);

        function handleRequestedEntityFound(index) {
            that.renderer._deviceEntityGrid.renderer.scrollToTheRow(index);
            that.pagingFeed.removeListener("RequestedEntityFound", handleRequestedEntityFound);
        }
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onEditorClosed(tabId /*, editorParams*/) {
        //let editorsIds = editorParams.launchOptions.deviceIds;
        if (this._explorerState.openedTabs[tabId]) {
            delete this._explorerState.openedTabs[tabId];
            if (
                Object.keys(this._explorerState.openedTabs).length === 1 &&
                this._explorerState.openedTabs.sessionToken
            ) {
                delete this._explorerState.openedTabs.sessionToken;
            }
        }
        if (this._explorerState.activeTab === tabId) {
            if (!_.isEmpty(this._explorerState.openedTabs)) {
                let openedTabsIds = Object.keys(this._explorerState.openedTabs);
                this.updateExplorerState("activeTab", openedTabsIds[openedTabsIds.length - 1]);
            } else {
                this.updateExplorerState("activeTab", undefined);
            }
        }
        this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
    }

    _onActiveTabChanged(tabId /*, editorParams*/) {
        if (this._explorerState.activeTab !== tabId) {
            this.updateExplorerState("activeTab", tabId);
        }
    }

    _onEditorLaunched(editorState, launchOpts) {
        if (!this._explorerState.openedTabs[launchOpts.id]) {
            let openedTab = Object.assign(editorState, launchOpts);
            this._explorerState.openedTabs[launchOpts.id] = openedTab;
            this.updateExplorerState("openedTabs", this._explorerState.openedTabs);
        }
        this.updateExplorerState("activeTab", launchOpts.id);
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._pagingSiteFeed.setSort(sort);
    }

    _onSolutionChanged(solution) {
        // whole pane will be reset, no need to make any action here
        this._solutionName = solution.name;
    }

    _onStorageReady() {}

    _onPropertiesUpdated(pristineProperties, before) {
        this._isEmitCustomFieldEvent = false;
        let updatedColumnKeys = pristineProperties.fields;
        let previousColumnKeys = before.fields;
        let editedColumn = Object.assign(
            {},
            ..._.reduce(
                updatedColumnKeys,
                (result, value, key) => {
                    return _.isEqual(value, previousColumnKeys[key])
                        ? result
                        : result.concat({
                              [key]: value,
                          });
                },
                []
            )
        );
        if (Object.keys(updatedColumnKeys).length !== Object.keys(previousColumnKeys).length) {
            this._isEmitCustomFieldEvent = true;
        } else {
            for (let key of Object.keys(editedColumn)) {
                if (
                    !updatedColumnKeys[key].enabled &&
                    updatedColumnKeys[key].enabled === previousColumnKeys[key].enabled
                ) {
                    this._isEmitCustomFieldEvent = false;
                } else {
                    this._isEmitCustomFieldEvent = true;
                    break;
                }
            }
        }
        if (this._isEmitCustomFieldEvent) {
            this.emit("GridColumnUpdated", pristineProperties, before);
        }
    }

    _loadAllSites() {
        this._sitesList = Object.values(this._siteFeed.cache);
        return Promise.resolve();
    }

    _onSitePanelVisibilityChanged(isVisible) {
        if (isVisible) {
            if (this._siteFeed) {
                this._onSiteFeedUpdated();
            } else {
                this._startSiteFeed().then(() => this._onSiteFeedUpdated());
            }
        } else {
            this._stopSiteFeed();
        }
    }

    _onSiteFeedUpdated() {
        this.emit("RegenerateTreeData");
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    // openDeviceInstanceEditor(ids, fullyQualifiedViewName) {
    //     if (Array.isArray(ids) && ids.length > 1) {
    //         this._gameEditor.launchDeviceMultiEditor(ids);
    //     } else if ((Array.isArray(ids) && ids.length) || (typeof ids === "string" && ids !== "")) {
    //         const id = Array.isArray(ids) ? ids[0] : ids,
    //             fqn = fullyQualifiedViewName || Registrations.SIE_VIEW_DETAILS,
    //             device = this._pagingSiteFeed.getSiteEntityById(id),
    //             title = _.get(device, "name", "");
    //         this._gameEditor.launchDeviceEditor(
    //             {
    //                 fqn
    //             },
    //             {
    //                 id,
    //                 title
    //             }
    //         );
    //     }
    // }

    openSiteInstanceEditor(ids, fullyQualifiedViewName) {
        if (Array.isArray(ids) && ids.length > 1) {
            this._gameEditor.launchSiteMultiEditor(ids);
        } else if ((Array.isArray(ids) && ids.length) || (typeof ids === "string" && ids !== "")) {
            const id = Array.isArray(ids) ? ids[0] : ids,
                fqn = fullyQualifiedViewName || Registrations.SIE_VIEW_DETAILS,
                device = this._pagingSiteFeed.getSiteEntityById(id),
                title = _.get(device, "name", "");
            this._gameEditor.launchDeviceEditor(
                {
                    fqn,
                },
                {
                    id,
                    title,
                }
            );
        }
    }

    getSelectedSiteIds() {
        return _.get(this._explorerState, "selectedIds", []);
    }

    generateTreeData(sites, selectedSite) {
        const sitesList = sites || this._sitesList;
        // console.log(sitesList);
        if (!sitesList || sitesList.length < 0) {
            return [];
        }

        const treeData = TreeUtils.generateTreeNodesFromRaw(sitesList, "path", selectedSite);
        // console.log(treeData);
        return treeData.items;
    }

    updatePathForSite(id, parentId) {
        return this._siteEntityDef.loadSite(this.activeOrgId, id).then((site) => {
            // console.log(site, parentId);
            if (parentId) {
                site.setParentSiteRelationship(parentId);
            } else {
                site.clearParentSiteRelationship();
            }

            return site.update();
        });
    }

    loadAllSites() {
        return this._loadAllSites().then(() => this._sitesList);
    }

    deleteSite(id, name) {
        if (!id) {
            return Promise.resolve("Missing site ID");
        }
        const SiteEntityDef = this._siteEntityDef;
        let idsToDelete = [];
        return deleteSiteUtility
            .expandSiteIds(SiteEntityDef, this.activeOrgId, [id])
            .then((expandedIds) => {
                idsToDelete = expandedIds;
                return deleteSiteUtility.checkDeleteBlockers(
                    SiteEntityDef,
                    this.activeOrgId,
                    idsToDelete
                );
            })
            .then((blockers) => {
                if (blockers.hasDeviceSite) {
                    return Promise.reject({
                        msg: deleteSiteUtility.buildDeviceSiteMessage(blockers.hasDeviceSiteCount),
                    });
                }

                let message = deleteSiteUtility.buildSingleSiteDeleteMessage({
                    siteName: name,
                    expandedIds: idsToDelete,
                    hasChildSite: blockers.hasChildSite,
                });

                return this._gameEditor.runQuickConfirmationActionWorkflow(
                    {
                        message,
                        title: "Delete",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    },
                    () => {
                        return SiteEntityDef.runSiteDeleteWork(
                            this.activeOrgId,
                            deleteSiteUtility.buildWorkTarget(idsToDelete),
                            {},
                            {launchAndForget: false},
                            deleteSiteUtility.makeProgressCallback(this._modalUserFeedback)
                        )
                            .then((workResults) => {
                                SiteEntityDef.throwWorkErrors(workResults);
                                if (this.pagingFeed && this.pagingFeed.feedUpdate) {
                                    this.pagingFeed.feedUpdate();
                                }
                                this.emit("RegenerateTreeData");
                                return Promise.resolve();
                            })
                            .catch((err) => {
                                // Work rejections arrive as a plain object with errorMsg,
                                // not as an Error, so check both shapes.
                                const errText = err.message || err.errorMsg || "";
                                if (errText.search("EntityInteractionsError") !== -1) {
                                    return this._modalUserFeedback.displayError({
                                        error: {
                                            errorMsg:
                                                "Sorry, you can’t delete a site that has devices assigned to it. Remove the devices from the site and any child site.",
                                        },
                                    });
                                }
                                this._logger.warn(
                                    {error: err},
                                    "SiteGridViewComponent.deleteSite() - Error"
                                );
                                return this._modalUserFeedback.displayError(err).catch(() => {
                                    return Promise.resolve();
                                });
                            });
                    }
                );
            })
            .catch((err) => {
                this._logger.warn({error: err}, "SiteGridViewComponent.deleteSite() - Error");
                return this._modalUserFeedback.displayError(
                    err.msg ? {errorMsg: err.msg, errorCode: ""} : err
                );
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SiteGridViewComponent;

SiteGridViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.utils",
    "$teve.userSession",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.ui.userFeedback",
    "$teve.licenseRestriction",
    "$teve.di",
    "$teve.entities.Site",
    "$teve.entities.CustomFields",
    "$teve.entities.Credentials",
];

SiteGridViewComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "siteexplorer.site",
    shown: false,
    order: 1,
};
